import './styles/style.scss';
import {gsap} from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import header from './blocks/header_block';
import hero from './blocks/hero_block';
import {initBlocks} from './blocks';
import {getHeightOfViewPort} from './scripts/functions/getHeightOfViewPort';
import {generateDataHover} from './scripts/functions/generateDataHover';
import {initModal} from "./scripts/general/custom-modal";
import {openPopup} from "./scripts/general/open-popup";
import {scrollToHash} from './scripts/general/scroll-to-hash';
import {activePage} from "./scripts/general/active-page";
import {updateSVGInPictures} from "./scripts/general/updateSVGInPictures";
import {normalizeAccessibilityMarkup} from './scripts/general/accessibility-runtime';

const reInvokableFunction = async (container = document) => {
  container.querySelector('header') && await header(container.querySelector('header'));
  container.querySelector('.hero_block') && await hero(container.querySelector('.hero_block'));
  await initBlocks(container);
  generateDataHover(container);
  scrollToHash(container);
  getHeightOfViewPort(container);
  activePage(container);
  initModal()
  openPopup(container);
  updateSVGInPictures();
  normalizeAccessibilityMarkup(container);
  const isWarm = document.body.classList.contains('warm-red-page');


  if (isWarm) {
    gsap.to(document.body,{backgroundColor:'#f84e35', ease:'none', scrollTrigger:{
        scrub:1,
        trigger:'.color-start',
        endTrigger: '.color-end',
        start:()=>'bottom center',
        end:()=>'top center',
      }})
  }



  ScrollTrigger.refresh(false);

};
let loaded = false;

async function onLoad() {
  gsap.config({
    nullTargetWarn: false,
  });
  if (document.readyState === 'interactive' && !loaded) {
    loaded = true;

    // Do not hide the whole document while JS initializes. Visually hidden
    // page content can remain exposed to assistive technology and trigger
    // accessibility failures. Mark the page as loaded immediately instead.
    document.body.classList.add('loaded');

    gsap.registerPlugin(ScrollTrigger);
    await reInvokableFunction();

    //region force page to scroll to element if url has hash
    let currentURL = window.location.href;
    let blockID = currentURL.split('#');
    if (blockID && blockID[1]) {
      let block = document.querySelector('#' + blockID[1]);
      if (block) {
        setTimeout(() => {
          window.scrollTo(0, (block.getBoundingClientRect().top + window.scrollY - window.headerSticky ? window.headerSticky : 93))
        }, 400)
      }
    }
    //endregion force page to scroll to element if url has hash
  }
}

onLoad();

document.onreadystatechange = function () {
  onLoad();
};
